<app-card-content [headerColor]="false" icon="pi pi-envelope" title="Correspondências" subtitle="Correspondências encaminhadas para este prestador">
    <app-custom-table
        [metadata]="metadata"
        [data]="correspondenciasTabela()"
        [columnOrder]="['numero', 'tipoCorrespondencia', 'dataCorrespondencia', 'setor']"
        [loading]="loading()"
        [first]="first()"
        [totalRecords]="totalRecords()"
        [rows]="rows()"
        [showActions]="false"
        [initialViewMode]="'table'"
        (onPageChange)="onPaginaAlterada($event)"
    />
</app-card-content>
